/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import AccommodationInvoice from './AccommodationInvoice'
import AccommodationInvoiceDetail from './AccommodationInvoiceDetail'
import Reservation from './Reservation'

/**
 * The InlineResponse20018 model module.
 * @module model/InlineResponse20018
 * @version 1.0.0
 */
export default class InlineResponse20018 {
  /**
   * Constructs a new <code>InlineResponse20018</code>.
   * @alias module:model/InlineResponse20018
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20018</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20018} obj Optional instance to populate.
   * @return {module:model/InlineResponse20018} The populated <code>InlineResponse20018</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20018()

      if (data.hasOwnProperty('invoice')) {
        obj['invoice'] = AccommodationInvoice.constructFromObject(data['invoice'])
      }
      if (data.hasOwnProperty('invoice_details')) {
        obj['invoice_details'] = ApiClient.convertToType(data['invoice_details'], [AccommodationInvoiceDetail])
      }
      if (data.hasOwnProperty('reservation')) {
        obj['reservation'] = Reservation.constructFromObject(data['reservation'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/AccommodationInvoice} invoice
   */
  invoice = undefined
  /**
   * @member {Array.<module:model/AccommodationInvoiceDetail>} invoice_details
   */
  invoice_details = undefined
  /**
   * @member {module:model/Reservation} reservation
   */
  reservation = undefined
}
